import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'
export interface IAddCompanyToWishListPayload extends ISagaCb {
    id: string
    data: {
        companyIds?: string[]
    }
    sagaCB: {
        onSuccess: any
    }
}

interface IAddCompanyToWishListState {
    status: string
    data: any
    errors: any
}

const initialState: IAddCompanyToWishListState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const wishListsAddCompanySlice = createSlice({
    name: 'hub/wish-lists/add-company',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IAddCompanyToWishListPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const wishListsAddCompanyActions = wishListsAddCompanySlice.actions
export default wishListsAddCompanySlice.reducer
